<template>
    <v-card class="my-5">
        <v-card-title>Algemeen</v-card-title>
        <v-card-text>
            <v-list>
                <v-list-item class="pa-0">
                    <v-list-item-content>
                        <v-list-item-subtitle>Tags</v-list-item-subtitle>
                        <v-list-item-title>
                            <v-chip-group>
                                <v-chip small v-for="tag in item.tags" :key="tag.id">
                                    {{ tag.name }}
                                </v-chip>
                            </v-chip-group>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item class="pa-0">
                    <v-list-item-content>
                        <v-list-item-subtitle>Regio's</v-list-item-subtitle>
                        <v-list-item-title>
                            <v-chip-group>
                                <v-chip small v-for="region in item.regions" :key="region.id">
                                    {{ region.name }}
                                </v-chip>
                            </v-chip-group>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item class="pa-0">
                    <v-list-item-content>
                        <v-list-item-subtitle>Website link</v-list-item-subtitle>
                        <v-list-item-title>
                            <a :href="webUrl + item.full_url" target="_blank">
                                {{ webUrl }}{{ item.full_url }}
                            </a>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item class="pa-0">
                    <v-list-item-content>
                        <v-list-item-subtitle>Samenvatting</v-list-item-subtitle>
                        <v-list-item-title style="white-space: normal">
                            {{ item.description }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "PackageGeneralInfo",
    props: {
        item: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            webUrl: window.config.WEBSITE_URL,
        }
    },
    methods: {
        saved() {
            this.$emit('savedProduct');
        }
    }
}
</script>
